var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojioneV1FlagForItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.25H26.25V33.75H13.75V6.25Z",
    fill: "#F4F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.25C2.10813 6.25 0 9.32812 0 13.125V26.875C0 30.6719 2.10813 33.75 6.25 33.75H13.75V6.25H6.25Z",
    fill: "#008C45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 6.25H26.25V33.75H33.75C37.8919 33.75 40 30.6719 40 26.875V13.125C40 9.32812 37.8919 6.25 33.75 6.25Z",
    fill: "#CD212A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneV1FlagForItaly);
export default __webpack_public_path__ + "static/media/emojione-v1_flag-for-italy.a5c0591a25ecef8726b41afbfce6a260.svg";
export { ForwardRef as ReactComponent };